<template>
  <div class="container-fluid background--light">
    <div class="container" v-if="token">
      <div class="section section--small">
        <div class="h2 h2--primary">Potwierdzenie płatności</div>
      </div>
      <div class="section section--small">
        <div v-if="loading">Trwa wczytywanie...</div>
        <div class="payment-status" v-else>
          <div v-if="paymentInfo.status === 'paid'">
            <div class="payment_header">
              <div class="check"><i class="fa fa-check" aria-hidden="true"></i></div>
            </div>
            <div class="content">
              <h1>Zamówienie opłacone</h1>
              <p>Twoje zamówienie jest w pełni opłacone</p>
              <router-link :to="{ name: 'OrderCompleted', params: { token: token } }" class="button button--primary button--big button--width">
                Zobacz zamówienie
              </router-link>
            </div>
          </div>
          <div v-else-if="paymentInfo.status === 'cancelled'">
            <div class="payment_header">
              <div class="check">
                <i class="fas fa-times"></i>
              </div>
            </div>
            <div class="content">
              <h1>Płatność anulowana</h1>
              <p>Twoja płatność została anulowana</p>
            </div>
          </div>
          <div v-else>
            <div class="payment_header">
              <div class="check">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
            </div>
            <div class="content">
              <h1>Płatność przetwarzana</h1>
              <p>Twoja płatność jest obecnie przetwarzana.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/scss/pages/order-payment-and-summary";
</style>

<script>
import { actionTypes } from "@/store/modules/Order/action-types";
import {mapActions, mapGetters} from "vuex";
import {getterTypes} from "@/store/modules/Order/getter-types";

export default {
  name: "OrderPaymentStatus",
  metaInfo: {
    titleTemplate: "%s - Status płatności",
  },
  props: {
    token: {
      type: String,
    }
  },
  computed: {
    paymentInfo() {
      return this.GET_PAYMENT_INFO();
    }
  },
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    ...mapActions("OrderModule", [actionTypes.ADD_PAYMENT_INFO]),
    ...mapGetters("OrderModule", [
      getterTypes.GET_PAYMENT_INFO,
    ]),
  },
  async created() {
    if (this.token) {
       let interval = setInterval(async () => {
         await this.ADD_PAYMENT_INFO(this.token);
         let paymentInfo = this.GET_PAYMENT_INFO();
         if (null !== paymentInfo) {
           if (paymentInfo.status === 'paid' || paymentInfo.status === 'cancelled') {
             clearInterval(interval);
           }
         }
      }, 2000);
      this.loading = false;
    }
  },
}
</script>
